<template>
	<div class="container">
		<div class="content">
			<!-- 主要内容 -->
			<div class="main-content">
				<div class="left-column">
					<!-- 投保流程 -->
					<div class="card" v-if="processSteps && processSteps.length > 0">
						<div class="card-title">
							<i class="el-icon-s-claim"></i>
							投保流程
						</div>

						<div class="process-steps">
							<div class="step" v-for="(step, index) in processSteps" :key="index">
								<div class="step-number">{{ index + 1 }}</div>
								<div class="step-content">
									<h3>{{ step.title }}</h3>
									<p>{{ step.description }}</p>
								</div>
							</div>
						</div>
					</div>

					<!-- 投保指南 -->
					<div class="card" v-if="guideItems && guideItems.length > 0">
						<div class="card-title">
							<i class="el-icon-guide"></i>
							投保指南
						</div>

						<div class="guide-content">
							<div class="guide-item" v-for="(item, index) in guideItems" :key="index">
								<div class="guide-icon">
									<i :class="item.icon"></i>
								</div>
								<div class="guide-text">
									<h3>{{ item.title }}</h3>
									<p>{{ item.description }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 侧边栏 -->
				<div class="sidebar">
					<!-- 联系客服 -->
					<div class="contact-card">
						<h3><i class="el-icon-phone"></i> 联系客服</h3>
						<div class="contact-info">
							<p>客服热线：{{ $getter('setting').value1 }}</p>
							<p>服务时间：{{ $getter('setting').value4 }}</p>
						</div>
					</div>

					<!-- 投保小贴士 -->
					<div class="card tips-card" v-if="tipItems && tipItems.length > 0">
						<div class="card-title">
							<i class="el-icon-s-opportunity"></i>
							投保小贴士
						</div>
						<ul>
							<li v-for="(tip, index) in tipItems" :key="index">
								<i class="el-icon-success"></i>
								<span><strong>{{ tip.title }}：</strong>{{ tip.content }}</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				processSteps: [],
				guideItems: [],
				tipItems: []
			}
		},
		mounted() {
			this.getPageData();
		},
		methods: {
			getPageData() {
				this.$get('app-page-design/3').then(res => {
					if (res.data && res.data.content) {
						try {
							const data = typeof res.data.content === 'string' ? 
								JSON.parse(res.data.content) : res.data.content;
							
							this.processSteps = data.processSteps || [];
							this.guideItems = data.guideItems || [];
							this.tipItems = data.tipItems || [];
						} catch (error) {
							console.error('解析页面数据失败:', error);
							this.initDefaultData();
						}
					} else {
						this.initDefaultData();
					}
				}).catch(err => {
					console.error('获取页面数据失败:', err);
					this.initDefaultData();
				});
			},
			
			initDefaultData() {
				// 如果获取数据失败，使用默认数据
				this.processSteps = [
					{
						title: '选择产品',
						description: '根据您的旅行目的地、时长和活动类型，选择最适合的保险方案。'
					},
					{
						title: '填写信息',
						description: '准确填写投保人、被保险人的个人信息，确保与证件信息一致。'
					},
					{
						title: '确认保障',
						description: '仔细阅读保险条款，了解保障范围、责任免除和理赔流程。'
					},
					{
						title: '支付保费',
						description: '选择支付方式完成保费支付，支持微信、支付宝等多种方式。'
					},
					{
						title: '获取保单',
						description: '支付成功后立即获取电子保单，可随时查看和下载。'
					}
				];
				
				this.guideItems = [
					{
						icon: 'el-icon-s-claim',
						title: '选择适合的保险产品',
						description: '根据旅行类型选择适合的保险，我们提供高原、徒步、水上活动等专项保险。'
					},
					{
						icon: 'el-icon-s-custom',
						title: '准确填写个人信息',
						description: '确保姓名、身份证号等信息与证件一致，避免影响后续理赔。'
					},
					{
						icon: 'el-icon-s-flag',
						title: '合理选择保险期间',
						description: '保险期间应覆盖整个旅行周期，包括出发和返程日。'
					},
					{
						icon: 'el-icon-s-order',
						title: '仔细阅读保险条款',
						description: '了解保障范围、责任免除和理赔流程等重要信息。'
					}
				];
				
				this.tipItems = [
					{
						title: '提前购买',
						content: '建议提前1-2天购买保险，确保保险生效'
					},
					{
						title: '核对信息',
						content: '仔细核对个人信息，避免填写错误'
					},
					{
						title: '保存保单',
						content: '保存好电子保单，出行时随身携带'
					},
					{
						title: '了解救援',
						content: '了解紧急救援服务流程，以备不时之需'
					},
					{
						title: '高风险活动',
						content: '高风险活动需购买专项保险产品'
					}
				];
			}
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;	
			/* 页面标题 */
			.page-header {
				background: white;
				padding: 25px 20px;
				text-align: center;
				box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
				border-radius: 12px;
				margin-bottom: 20px;
			}

			.page-header h1 {
				font-size: 24px;
				font-weight: 600;
				margin-bottom: 8px;
				color: #333;
			}

			.page-header p {
				font-size: 16px;
				color: #666;
				max-width: 600px;
				margin: 0 auto;
			}

			/* 主要内容区域 */
			.main-content {
				display: grid;
				grid-template-columns: 1fr;
				gap: 20px;
			}

			@media (min-width: 768px) {
				.main-content {
					grid-template-columns: 2fr 1fr;
				}
			}

			/* 卡片样式 */
			.card {
				margin-bottom: 20px;
				background: white;
				border-radius: 12px;
				padding: 25px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
				transition: transform 0.3s ease, box-shadow 0.3s ease;
			}

			.card:hover {
				transform: translateY(-3px);
				box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
			}

			.card-title {
				font-size: 20px;
				font-weight: 600;
				margin-bottom: 20px;
				color: #333;
				display: flex;
				align-items: center;
				gap: 10px;
				padding-bottom: 15px;
				border-bottom: 1px solid #f0f0f0;
			}

			.card-title i {
				color: #2280FD;
			}

			/* 流程步骤 */
			.process-steps {
				display: flex;
				flex-direction: column;
				gap: 20px;
				margin-bottom: 25px;
			}

			.step {
				display: flex;
				align-items: flex-start;
				gap: 15px;
			}

			.step-number {
				width: 36px;
				height: 36px;
				background: #2280FD;
				color: white;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 16px;
				font-weight: 600;
				flex-shrink: 0;
			}

			.step-content h3 {
				font-size: 18px;
				font-weight: 600;
				margin-bottom: 8px;
				color: #333;
			}

			.step-content p {
				font-size: 15px;
				color: #666;
				line-height: 1.6;
			}

			/* 指南内容 */
			.guide-content {
				display: grid;
				grid-template-columns: 1fr;
				gap: 20px;
			}

			@media (min-width: 480px) {
				.guide-content {
					grid-template-columns: 1fr 1fr;
				}
			}

			.guide-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				text-align: center;
				padding: 20px 15px;
				background: #f9fafb;
				border-radius: 10px;
				transition: all 0.3s ease;
			}

			.guide-item:hover {
				background: #f0f7ff;
				transform: translateY(-5px);
			}

			.guide-icon {
				width: 60px;
				height: 60px;
				background: rgba(34, 128, 253, 0.1);
				color: #2280FD;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 24px;
				margin-bottom: 15px;
			}

			.guide-text h3 {
				font-size: 16px;
				font-weight: 600;
				margin-bottom: 8px;
				color: #333;
			}

			.guide-text p {
				font-size: 14px;
				color: #666;
				line-height: 1.5;
			}

			/* 常见问题 */
			.faq-list {
				display: flex;
				flex-direction: column;
				gap: 15px;
			}

			.faq-item {
				border-radius: 8px;
				overflow: hidden;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
				transition: all 0.3s ease;
			}

			.faq-item:hover {
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
			}

			.faq-question {
				background: #f9f9f9;
				padding: 18px 20px;
				font-size: 16px;
				font-weight: 600;
				color: #333;
				cursor: pointer;
				display: flex;
				justify-content: space-between;
				align-items: center;
				transition: background 0.3s;
			}

			.faq-question:hover {
				background: #f0f0f0;
			}

			.faq-question i {
				color: #2280FD;
				transition: transform 0.3s;
			}

			.faq-answer {
				padding: 0 20px;
				max-height: 0;
				overflow: hidden;
				transition: all 0.3s ease;
				background: white;
			}

			.faq-answer p {
				padding: 15px 0;
				font-size: 15px;
				color: #666;
				line-height: 1.6;
			}

			.faq-item.active .faq-answer {
				max-height: 500px;
			}

			.faq-item.active .faq-question i {
				transform: rotate(180deg);
			}

			/* 侧边栏 */
			.sidebar {
				display: flex;
				flex-direction: column;
				gap: 20px;
			}

			.contact-card {
				background: linear-gradient(135deg, #2280FD 0%, #1a6fd0 100%);
				color: white;
				border-radius: 12px;
				padding: 25px;
				text-align: center;
			}

			.contact-card h3 {
				font-size: 20px;
				margin-bottom: 15px;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 10px;
			}

			.contact-info {
				margin-bottom: 20px;
			}

			.contact-info p {
				margin-bottom: 8px;
				font-size: 15px;
			}

			.contact-btn {
				display: inline-block;
				background: white;
				color: #2280FD;
				padding: 12px 25px;
				border-radius: 8px;
				font-weight: 600;
				text-decoration: none;
				transition: all 0.3s;
			}

			.contact-btn:hover {
				transform: translateY(-2px);
				box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
			}

			.tips-card ul {
				list-style: none;
				padding-left: 0;
			}

			.tips-card li {
				padding: 12px 0;
				border-bottom: 1px solid #f0f0f0;
				display: flex;
				align-items: flex-start;
				gap: 10px;
			}

			.tips-card li:last-child {
				border-bottom: none;
			}

			.tips-card i {
				color: #2280FD;
				margin-top: 3px;
			}

			.tips-card span strong {
				color: #333;
			}

			/* 行动按钮 */
			.action-section {
				background: white;
				padding: 25px 20px;
				text-align: center;
				border-radius: 12px;
				box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
			}

			.action-buttons {
				display: flex;
				gap: 15px;
				justify-content: center;
				flex-wrap: wrap;
			}

			.btn {
				padding: 14px 30px;
				border: none;
				border-radius: 8px;
				font-size: 16px;
				font-weight: 600;
				cursor: pointer;
				transition: all 0.3s ease;
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.btn-primary {
				background: #2280FD;
				color: white;
				box-shadow: 0 4px 12px rgba(34, 128, 253, 0.3);
			}

			.btn-primary:hover {
				background: #1a6fd0;
				transform: translateY(-2px);
				box-shadow: 0 6px 15px rgba(34, 128, 253, 0.4);
			}

			.btn-secondary {
				background: white;
				color: #2280FD;
				border: 1.5px solid #2280FD;
			}

			.btn-secondary:hover {
				background: rgba(34, 128, 253, 0.05);
				transform: translateY(-2px);
			}

			/* 动画效果 */
			@keyframes fadeIn {
				from {
					opacity: 0;
					transform: translateY(20px);
				}

				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			.card {
				animation: fadeIn 0.5s ease-out;
			}

			.step {
				animation: fadeIn 0.5s ease-out;
				animation-fill-mode: both;
			}

			.step:nth-child(1) {
				animation-delay: 0.1s;
			}

			.step:nth-child(2) {
				animation-delay: 0.2s;
			}

			.step:nth-child(3) {
				animation-delay: 0.3s;
			}

			.step:nth-child(4) {
				animation-delay: 0.4s;
			}

			.step:nth-child(5) {
				animation-delay: 0.5s;
			}
		}
	}
</style>